export interface ILanguage {
  _id?: string;
  level?: string;
  name?: string;
  title?: string;
}

export class Language implements ILanguage {
  _id?: string;
  level: string;
  name: string;
  title: string;

  constructor( language: ILanguage = {} ) {
    this._id = language._id;
    this.level = language.level;
    this.name = language.name;
    this.title = language.title;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/language.ts